import type { RouteObject } from "react-router-dom";

export const supportRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Support" },
    async lazy() {
      const { Page } = await import("../app/page");
      return {
        element: (
          <Page
            hidePadding={(url) =>
              url.endsWith("/support") || url.endsWith("/support/")
            }
          />
        ),
      };
    },
    children: [
      {
        index: true,
        handle: { breadcrumb: "Conversation Analytics" },
        async lazy() {
          const { ConversationAnalytics } = await import(
            "./conversation-analytics/conversation-analytics"
          );
          return { Component: ConversationAnalytics };
        },
      },
      {
        path: "conversation-analytics",
        handle: { breadcrumb: "Conversation Analytics" },
        async lazy() {
          const { ConversationAnalytics } = await import(
            "./conversation-analytics/conversation-analytics"
          );
          return { Component: ConversationAnalytics };
        },
      },
      {
        path: "ab-testing",
        handle: { breadcrumb: "A/B Testing" },
        async lazy() {
          const { SupportDashboard } = await import("./support-dashboard");
          return { Component: SupportDashboard };
        },
      },
      {
        path: "split/:splitName",
        handle: { breadcrumb: "Split Analytics" },
        async lazy() {
          const { SupportAgentSplitAnalyticsPage } = await import(
            "./support-agent-split-analytics-page"
          );
          return { Component: SupportAgentSplitAnalyticsPage };
        },
      },
    ],
  },
];
